import { Box, Group, Paper, Skeleton, Stack } from '@mantine/core'

const ContentCheckSkeleton = () => (
  <Box py={24}>
    <Skeleton height={36} width={300} mb={32} />
    {[1, 2].map((i) => (
      <Box key={i} mb={32}>
        <Paper withBorder p={36} bg='lightgray' radius={16}>
          <Stack gap={20}>
            <Group justify='space-between'>
              <Skeleton height={36} width={200} />
              <Skeleton height={24} width={150} />
            </Group>
            <Stack>
              {[1, 2].map((j) => (
                <Paper
                  key={j}
                  withBorder
                  shadow='md'
                  h={400}
                  p={24}
                  radius={16}
                >
                  <Group justify='space-between' align='flex-start' h='100%'>
                    <Group h='100%' gap={32} align='flex-start'>
                      <Skeleton height={352} width={250} />
                      <Stack>
                        <Skeleton height={36} width={200} />
                        <Skeleton height={24} width={150} />
                        <Skeleton height={24} width={180} />
                      </Stack>
                    </Group>
                    <Stack miw={300} align='flex-start'>
                      <Skeleton height={24} width={120} />
                      <Skeleton height={100} width='100%' />
                    </Stack>
                  </Group>
                </Paper>
              ))}
            </Stack>
            <Group justify='flex-end'>
              <Skeleton height={36} width={100} />
            </Group>
          </Stack>
        </Paper>
      </Box>
    ))}
  </Box>
)

export default ContentCheckSkeleton
